import { Logger, getWindow } from '@sitecore-search/common';
import { getServiceConfig, setup as setupDataLayer } from '@sitecore-search/data';
import Actions from './actions.js';
import PageController from './controller/page.js';
import WidgetsConfigDataProviderProcessor from './dataProviderProcessor.js';
import WidgetsConfig from './widgetsConfig.js';
export const setCredentials = (dataOptions) => {
    setupDataLayer(dataOptions, { processor: new WidgetsConfigDataProviderProcessor() });
};
const setupPageContext = () => {
    const { trackConsent } = getServiceConfig();
    PageController.toggleTrackConsent(trackConsent);
    PageController.getContext().setBrowserUserAgent(getWindow({ navigator: { userAgent: '' } }).navigator.userAgent);
};
let initialized = false;
export const init = () => {
    if (initialized) {
        return;
    }
    setupPageContext();
    initialized = true;
    PageController.getDispatcher().dispatch({
        type: Actions.INITIALIZE,
        payload: {
            options: {},
        },
    });
};
export const setWidgetType = (type, mapping) => {
    Logger.debug('setWidgetType', `Type: ${type}`, `Mapping: ${JSON.stringify(mapping)}`);
    WidgetsConfig.setWidgetType(type, mapping);
};
export function setWidget(rfkId, entityOrConfig, config) {
    if (typeof entityOrConfig === 'string') {
        Logger.info('setWidget', rfkId, entityOrConfig, JSON.stringify(config));
        WidgetsConfig.update(rfkId, entityOrConfig, config);
    }
    else {
        Logger.info('setWidget', rfkId, JSON.stringify(config));
        WidgetsConfig.update(rfkId, config);
    }
}
